import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["note"]

  reasonChanged(event) {
    this.noteTarget.required = event.target.value === "other"
  }
}
